module.exports = __webpack_public_path__ + "static/media/aerovinum-logo.9e18b8e8.png";